import { useEffect, useState } from 'react'
import { isEmpty, isNotEmpty } from '../../Utility'

/**
 * Un componente React che rende un campo di input con un'etichetta flottante.
 * L'etichetta si sposta sopra il campo di input quando è presente un valore.
 *
 * @param {string} value - Il valore corrente del campo di input.
 * @param {string} [type='text'] - L'attributo tipo per l'elemento input.
 * @param {string} error - Messaggio di errore da visualizzare sotto il campo di input.
 * @param {boolean} disabled - Se il campo di input è disabilitato.
 * @param {string} label - Il testo dell'etichetta che fluttua sopra il campo di input.
 * @param {function} onChange - Funzione di callback per gestire le modifiche del valore dell'input.
 * @param {function} onBlur - Funzione di callback per gestire gli eventi di perdita di fuoco dell'input.
 * @param {string} placeholder - Testo segnaposto per il campo di input.
 * @param {number} maxLength - Lunghezza massima del valore dell'input.
 */
export function FloatLabelTextBox({
  value,
  type,
  error,
  disabled,
  label,
  onChange,
  onBlur,
  placeholder,
  maxLength
}) {
  const [empty, setEmpty] = useState(true) //necessario al funzionamento della label mobile

  useEffect(() => {
    setEmpty(isEmpty(value))
  }, [value])

  /**
   * Funzione di callback per gestire l'evento blur dell'input.
   * Aggiorna lo stato locale empty e richiama la funzione onBlur
   * se questa è stata passata come prop.
   *
   * @param {Event} e - L'evento di blur dell'input.
   */
  const onBlurFunc = (e) => {
    setEmpty(isEmpty(value))
    if (onBlur) {
      onBlur(e)
    }
  }

  return (
    <div className="inputs">
      <label className="input">
        <input
          className={`input__field ${!empty && 'notEmpty'}`}
          type={type || 'text'}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={(e) => onBlurFunc(e)}
          disabled={disabled}
          maxLength={isNotEmpty(maxLength) ? maxLength : 255}
        />
        <span className="input__label">{label}</span>
      </label>
      <span className="input__error">{error}</span>
    </div>
  )
}
